import { Translations } from '.';

const pt: Record<Translations, string> = {
  ' de Abril': ' de Abril',
  ' de Agosto': ' de Agosto',
  ' de Dezembro': ' de Dezembro',
  ' de Fevereiro': ' de Fevereiro',
  ' de Janeiro': ' de Janeiro',
  ' de Julho': ' de Julho',
  ' de Junho': ' de Junho',
  ' de Maio': ' de Maio',
  ' de Março': ' de Março',
  ' de Novembro': ' de Novembro',
  ' de Outubro': ' de Outubro',
  ' de Setembro': ' de Setembro',
  '+Adicionar': '+Adicionar',
  'A sigla deve conter no máximo 32 caracteres.':
    'A sigla deve conter no máximo 32 caracteres.',
  ADDRESS_INCOMPLETE: 'Endereço incompleto',
  ADDRESS_NOT_CREATED: 'Não foi possível criar o endereço',
  ADDRESS_NOT_UPDATED: 'Não foi possível atualizar o endereço',
  APPOINTMENT_CONTROL_API_CREATE_ERROR:
    'Problema ao enviar solicitações para criar controle de compromissos',
  APPOINTMENT_CONTROL_API_DELETE_ERROR:
    'Problema ao enviar solicitações para excluir controle de compromissos',
  APPOINTMENT_CONTROL_API_LIST_ERROR:
    'Problema ao enviar solicitações para listar controle de compromissos',
  AUTHORIZATION_API_COULD_NOT_ACTION_EXISTS:
    'Não foi possível verificar se a ação existe no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_CREATE_ACTION:
    'Não foi possível criar ação no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_CREATE_ACTION_TO_ROLE:
    'Não foi possível criar ação para a função no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_CREATE_RESOURCE:
    'Não foi possível criar recurso no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_CREATE_ROLE:
    'Não foi possível criar função no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_CREATE_USER:
    'Não foi possível criar usuário no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_GET_USER_ACL:
    'Não foi possível obter a ACL do usuário no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_GIVE_PERMISSION_TO_ROLE:
    'Não foi possível dar permissão para função no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_GIVE_PERMISSION_TO_USER:
    'Não foi possível dar permissão para usuário no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_GIVE_ROLE_TO_USER:
    'Não foi possível dar função para usuário no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_LIST_ACTIONS:
    'Não foi possível listar ações de autorização',
  AUTHORIZATION_API_COULD_NOT_LIST_RESOURCES:
    'Não foi possível listar recursos de autorização',
  AUTHORIZATION_API_COULD_NOT_LIST_ROLES:
    'Não foi possível listar funções de autorização',
  AUTHORIZATION_API_COULD_NOT_REMOVE_PERMISSION_TO_USER:
    'Não foi possível remover permissão do usuário no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_REMOVE_ROLE_PERMISSION:
    'Não foi possível remover a permissão de função no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_REMOVE_ROLE_TO_USER:
    'Não foi possível remover função do usuário no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_REMOVE_USER:
    'Não foi possível remover usuário do sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_RESOURCE_EXISTS:
    'Não foi possível verificar se o recurso existe no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_ROLE_ACTION_EXISTS:
    'Não foi possível verificar se a ação da função existe no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_ROLE_EXISTS:
    'Não foi possível verificar se a função existe no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_ROLE_PERMISSIONS:
    'Não foi possível obter as permissões da função no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_UPDATE_RESOURCE_TO_RESOURCE:
    'Não foi possível atualizar o recurso no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_UPDATE_ROLE:
    'Não foi possível atualizar a função no sistema de autorização',
  AUTHORIZATION_API_COULD_NOT_UPDATE_USER:
    'Não foi possível atualizar usuário no sistema de autorização',
  AUTHORIZATION_API_LOGIN_ERROR:
    'Não foi possível fazer login no sistema de autorização',
  AUTH_ACL_NOT_PROVIDED: 'A ACL do usuário deve ser fornecida para esta ação',
  AUTH_CONFIRMATION_TOKEN_INCORRECT: 'Token de confirmação incorreto',
  AUTH_COULD_NOT_LIST_USER:
    'Não foi possível listar a senha do usuário no serviço de autenticação',
  AUTH_COULD_NOT_RESET_PASSWORD:
    'Não foi possível redefinir a senha do usuário no serviço de autenticação',
  AUTH_EXTERNAL_TOKEN_INVALID: 'Token externo inválido',
  AUTH_FAILED: 'Falha na autenticação',
  AUTH_FORBIDDEN: 'Você não tem permissão para executar essa ação',
  AUTH_MISSING_AUTHORIZATION_HEADER: 'Cabeçalho de autorização ausente',
  AUTH_MULTIPLES_ORG_AVAILABLE: 'Múltiplas organizações disponíveis',
  AUTH_NOT_CREATED_USER:
    'Não foi possível criar usuário no serviço de autenticação',
  AUTH_NOT_DELETED_USER:
    'Não foi possível excluir usuário no serviço de autenticação',
  AUTH_NOT_UPDATED_USER:
    'Não foi possível atualizar usuário no serviço de autenticação',
  AUTH_PWD_RECOVERY_TOKEN_INCORRECT: 'Token de recuperação de senha incorreto',
  AUTH_REFRESH_FAILED: 'Não foi possível renovar o login',
  AUTH_REFRESH_INVALID_TOKEN: 'Token de renovação inválido',
  AUTH_USER_DOES_NOT_MATCH_WITH_TOKEN:
    'O ID do usuário não corresponde ao token',
  'Aceite os termos de uso e de gravação para iniciar.':
    'Aceite os termos de uso e de gravação para iniciar.',
  'Aceito os': 'Aceito os',
  'Aceito que o atendimento poderá ser gravado':
    'Aceito que o atendimento poderá ser gravado',
  'Aceito que o atendimento poderá ser gravado.':
    'Aceito que o atendimento poderá ser gravado.',
  Acessar: 'Acessar',
  'Acessas farmácia': 'Acessas farmácia',
  'Acesse o documento': 'Acesse o documento',
  'Acesso para farmácia': 'Acesso para farmácia',
  'Acesso à Receita': 'Acesso à Receita',
  Add: 'Add',
  'Adicionar novo usuário': 'Adicionar novo usuário',
  'Adicione participantes ou digite um novo e-mail':
    'Adicione participantes ou digite um novo e-mail',
  'Adicione um título': 'Adicione um título',
  'Adicione uma descrição': 'Adicione uma descrição',
  'Administrador Geral': 'Administrador Geral',
  Administrador: 'Administrador',
  'Administradores de sistema': 'Administradores de sistema',
  Administradores: 'Administradores',
  Administração: 'Administração',
  'Agenda de atendimentos': 'Agenda de atendimentos',
  Agenda: 'Agenda',
  Agendadas: 'Agendadas',
  Agendado: 'Agendado',
  Agendamentos: 'Agendamentos',
  'Agendar novo atendimento': 'Agendar novo atendimento',
  'Agendar reunião': 'Agendar atendimento',
  Agendar: 'Agendar',
  Agora: 'Agora',
  'Aguarde nesta tela.': 'Aguarde nesta tela.',
  'Aguarde o início do atendimento': 'Aguarde o início do atendimento',
  'Altere algum campo para atualizar o setor.':
    'Altere algum campo para atualizar o setor.',
  Anotações: 'Anotações',
  Anterior: 'Anterior',
  'Antes de entrar na sala de espera': 'Antes de entrar na sala de espera',
  'Antes de iniciar': 'Antes de iniciar',
  'Ao excluir um usuário, as informações pertinentes a eles como dados de atendimentos, documentos clínicos e de apoio como também as conversas em chat, serão mantidas de acordo com as politicas de privacidade e termos de uso da plataforma V4H atendimento. ':
    'Ao excluir um usuário, as informações pertinentes a eles como dados de atendimentos, documentos clínicos e de apoio como também as conversas em chat, serão mantidas de acordo com as politicas de privacidade e termos de uso da plataforma V4H atendimento. ',
  'Ao remover o usuário, algumas das informações associadas a ele (dados de consultas médicas, documentos clínicos e de suporte, conversas por chat) serão mantidas de acordo com as políticas de privacidade e termos de uso do serviço.':
    'Ao remover o usuário, algumas das informações associadas a ele (dados de consultas médicas, documentos clínicos e de suporte, conversas por chat) serão mantidas de acordo com as políticas de privacidade e termos de uso do serviço.',
  'Apenas esta reunião': 'Apenas este atendimento',
  'Armazenamento total': 'Armazenamento total',
  Armazenamento: 'Armazenamento',
  'Assessoria de Imprensa': 'Assessoria de Imprensa',
  Assessoria: 'Assessoria',
  Assinado: 'Assinado',
  'Assinar Documento': 'Assinar Documento',
  'Assinar agora': 'Assinar agora',
  'Assinar depois': 'Assinar depois',
  'Assinatura do documento': 'Assinatura do documento',
  Assinatura: 'Assinatura',
  'Atendimento cancelado': 'Atendimento cancelado',
  Atendimento: 'Atendimento',
  'Atestado Médico': 'Atestado Médico',
  Ativado: 'Ativado',
  'Atualizar imagem do usuário': 'Atualizar imagem do usuário',
  'Atualizar logo da organização': 'Atualizar logo da organização',
  'Atualizar organização': 'Atualizar organização',
  'Atualizar setor': 'Atualizar setor',
  Avançado: 'Avançado',
  Avançar: 'Avançar',
  'Aviso importante': 'Aviso importante',
  Avulso: 'Avulso',
  'Ações do atendimento': 'Ações do atendimento',
  Ações: 'Ações',
  Bairro: 'Bairro',
  'Baixar PDF': 'Baixar PDF',
  'Baixar conferência': 'Baixar conferência',
  'Baixar documento': 'Baixar documento',
  Blockchain: 'Blockchain',
  'Buscar por...': 'Buscar por...',
  'CEP inválido, existe(m) digitos faltando':
    'CEP inválido, existe(m) digitos faltando',
  'CEP inválido, número de digitos ultrapassou o limite':
    'CEP inválido, número de digitos ultrapassou o limite',
  'CEP inválido.': 'CEP inválido.',
  CEP: 'CEP',
  CONFERENCE_ALREADY_STARTED: 'A conferência já foi iniciada',
  CONFERENCE_BAD_RRULE:
    'Não foi possível criar recorrência para a regra fornecida',
  CONFERENCE_COULD_NOT_LIST:
    'Não foi possível listar as conferências no banco de dados',
  CONFERENCE_FILE_COULD_NOT_DELETE:
    'Não foi possível excluir o arquivo da conferência',
  CONFERENCE_FILE_NOT_CREATED:
    'Não foi possível criar o arquivo da conferência',
  CONFERENCE_FILE_NOT_FOUND: 'Arquivo da conferência não encontrado',
  CONFERENCE_IS_CANCELED: 'A conferência foi cancelada ou terminou',
  CONFERENCE_LIMIT_REACHED: 'Limite atingido. Pagamento é necessário',
  CONFERENCE_MEMBERS_USER_NOT_FOUND:
    'Não foi possível encontrar o usuário do participante',
  CONFERENCE_MEMBER_ALREADY: 'O usuário já é um participante',
  CONFERENCE_MEMBER_ALREADY_WITH_ROLE:
    'O participante já está atribuído a esta função',
  CONFERENCE_MEMBER_COULD_NOT_LIST:
    'Não foi possível listar os participantes no banco de dados',
  CONFERENCE_MEMBER_NOT_CREATED:
    'Não foi possível criar o membro da conferência no banco de dados',
  CONFERENCE_MEMBER_NOT_DELETED:
    'Não foi possível excluir o participante da conferência no banco de dados',
  CONFERENCE_MEMBER_NOT_FOUND: 'Não foi possível encontrar a conferência',
  CONFERENCE_NOTE_COULD_NOT_LIST:
    'Não foi possível listar as anotações da conferência no banco de dados',
  CONFERENCE_NOTE_CREATE_ERROR:
    'Não foi possível criar a anotação da conferência',
  CONFERENCE_NOTE_NOT_FOUND: 'Anotação da conferência não encontrada',
  CONFERENCE_NOT_CREATED:
    'Não foi possível criar a conferência no banco de dados',
  CONFERENCE_NOT_DELETED:
    'Não foi possível excluir a conferência no banco de dados',
  CONFERENCE_NOT_FOUND: 'Não foi possível encontrar a conferência',
  CONFERENCE_NOT_STARTED:
    'A conferência ainda não foi iniciada pelo proprietário',
  CONFERENCE_OWNER_CANNOT_QUIT:
    'O proprietário não pode sair de sua própria conferência',
  CONFERENCE_OWNER_NOT_IN_ORG:
    'O proprietário não é um membro desta organização',
  CONFERENCE_RECORDINGS_NOT_FOUND:
    'Não foram encontradas gravações para esta conferência',
  CONFERENCE_RECURRENCE_NOT_DELETED:
    'Não foi possível excluir recorrências da conferência no banco de dados',
  CONFERENCE_RECURRENCE_NOT_FOUND:
    'Não foi possível encontrar recorrências da conferência no banco de dados',
  CONFERENCE_RECURRENCE_NOT_UPDATED:
    'Não foi possível atualizar recorrências da conferência no banco de dados',
  CONFERENCE_RECURRENCE_NO_NEW:
    'A regra fornecida não cria novas recorrências. Por favor, forneça uma regra válida.',
  CONFERENCE_REGISTRY_NOT_FOUND:
    'Nenhum registro encontrado para esta conferência',
  CONFERENCE_SUMMARY_NOT_FOUND:
    'Não foi possível encontrar informações de resumo da conferência',
  CONFERENCE_TRANSCRIPTION_NOT_FOUND:
    'Nenhuma transcrição encontrada para esta conferência',
  CONFERENCE_WAITING_ROOM_DISABLED:
    'A conferência não tem sala de espera habilitada',
  'CPF inválido.': 'CPF inválido.',
  CPF: 'CPF',
  'Cadastrado em': 'Cadastrado em',
  Cadastrado: 'Cadastrado',
  Cadastrados: 'Cadastrados',
  'Cadastrar novo documento clínico': 'Cadastrar novo documento clínico',
  'Cadastrar novo organizador': 'Cadastrar novo organizador',
  'Cadastrar novo participante': 'Cadastrar novo participante',
  'Cadastrar novo profissional': 'Cadastrar novo profissional',
  'Cadastro de Pessoa Física': 'Cadastro de Pessoa Física',
  'Cadastro de conferência': 'Cadastro de conferência',
  Cadastro: 'Cadastro',
  'Campo obrigatório': 'Campo obrigatório',
  Cancelado: 'Cancelado',
  'Cancelar atendimento': 'Cancelar atendimento',
  'Cancelar atendimento?': 'Cancelar atendimento?',
  Cancelar: 'Cancelar',
  'Carregando...': 'Carregando...',
  'Centro de Atendimento ao cliente': 'Centro de Atendimento ao cliente',
  Cep: 'Cep',
  'Certificado Digital': 'Certificado Digital',
  Chat: 'Chat',
  Cidade: 'Cidade',
  'Classificação de organizações': 'Classificação de organizações',
  'Classificação de usuários': 'Classificação de usuários',
  'Clique para ver as notas de release': 'Clique para ver as notas de release',
  Cod: 'Cod',
  'Compartilhar por email': 'Compartilhar por email',
  Complemento: 'Complemento',
  Concluir: 'Concluir',
  'Conferência atualizada com sucesso': 'Conferência atualizada com sucesso',
  'Configurações da organização atualizadas com sucesso!':
    'Configurações da organização atualizadas com sucesso!',
  Configurações: 'Configurações',
  'Confime sua senha': 'Confime sua senha',
  Confirmado: 'Confirmado',
  'Confirmar nova senha': 'Confirmar nova senha',
  Confirmar: 'Confirmar',
  'Confirmação de conta': 'Confirmação de conta',
  'Confirmação de e-mail': 'Confirmação de e-mail',
  'Confirmação do cadastro de usuário': 'Confirmação do cadastro de usuário',
  'Confirme a senha': 'Confirme a senha',
  'Consultante inválido ou não encontrado.':
    'Consultante inválido ou não encontrado.',
  'Consumo por dia do mês': 'Consumo por dia do mês',
  'Consumo por serviço': 'Consumo por serviço',
  'Consumo por setor': 'Consumo por setor',
  'Consumo por usuário': 'Consumo por usuário',
  Consumo: 'Consumo',
  'Conta confirmada com sucesso!': 'Conta confirmada com sucesso!',
  Contato: 'Contato',
  Contatos: 'Contatos',
  Convidado: 'Convidado',
  Convidados: 'Convidados',
  'Convidar paciente para participar': 'Convidar paciente para participar',
  'Convidar profissional externo': 'Convidar profissional externo',
  'Copiar link de atendimento': 'Copiar link de atendimento',
  'Copiar link': 'Copiar link',
  Cpf: 'Cpf',
  'Criado em': 'Criado em',
  'Criação de Reunião Instantânea': 'Criação de Atendimento Instantânea',
  'Criação de organização': 'Criação de organização',
  'Criação de reunião': 'Criação de atendimento',
  'Criação de setor': 'Criação de setor',
  'Criação de usuário': 'Criação de usuário',
  'Código e Senha': 'Código e Senha',
  Código: 'Código',
  'Código:': 'Código:',
  DASHBOARD_COULD_NOT_GET: 'Não foi possível obter o painel',
  'DD/MM/AAAA': 'DD/MM/AAAA',
  DESATIVADA: 'DESATIVADA',
  DOCUMENT_CREATOR_CREATE:
    'Não foi possível criar o documento no serviço de criação de documentos',
  DOCUMENT_CREATOR_DOWNLOAD:
    'Não foi possível baixar o documento no serviço de criação de documentos',
  DOCUMENT_CREATOR_LOGIN_ERROR:
    'Não foi possível fazer login no serviço de criação de documentos',
  DOCUMENT_CREATOR_VERIFY:
    'Não foi possível verificar o documento no serviço de criação de documentos',
  'Dados Gerais': 'Dados Gerais',
  'Dados Pessoais': 'Dados Pessoais',
  'Dados Profissionais': 'Dados Profissionais',
  'Dados do paciente': 'Dados do paciente',
  'Dados do perfil': 'Dados do perfil',
  'Dados do profissional de saúde': 'Dados do profissional de saúde',
  'Dados gerais': 'Dados gerais',
  'Dados perfil': 'Dados perfil',
  'Dados profissionais': 'Dados profissionais',
  'Data de Nascimento': 'Data de Nascimento',
  'Data de emissão': 'Data de emissão',
  'Data de inclusão': 'Data de inclusão',
  'Data de nascimento é obrigatório.': 'Data de nascimento é obrigatório.',
  'Data de nascimento': 'Data de nascimento',
  'Data do Atendimento': 'Data do Atendimento',
  'Data do atendimento': 'Data do atendimento',
  'Data e Hora': 'Data e Hora',
  'Data e hora': 'Data e hora',
  'Data inválida': 'Data inválida',
  'Data inválida.': 'Data inválida.',
  Data: 'Data',
  'Deixar a sala': 'Deixar a sala',
  'Deixar sala': 'Deixar sala',
  Dentista: 'Dentista',
  Desativado: 'Desativado',
  'Descrição da reunião': 'Descrição do atendimento',
  Descrição: 'Descrição',
  'Deseja gerar um documento com a transcrição da reunião?':
    'Deseja gerar um documento com a transcrição do atendimento?',
  'Deseja realmente cancelar o atendimento: ':
    'Deseja realmente cancelar o atendimento: ',
  'Deseja realmente desvincular esse usuário da organização?':
    'Deseja realmente desvincular esse usuário da organização?',
  'Deseja realmente desvincular esse usuário do setor?':
    'Deseja realmente desvincular esse usuário do setor?',
  'Deseja realmente excluir a organização':
    'Deseja realmente excluir a organização',
  'Deseja realmente excluir a reunião?':
    'Deseja realmente excluir o atendimento?',
  'Deseja realmente excluir o setor?': 'Deseja realmente excluir o setor?',
  'Deseja realmente excluir o usuário': 'Deseja realmente excluir o usuário',
  Desligada: 'Desligada',
  Desligado: 'Desligado',
  'Desvincular Organizador do Setor': 'Desvincular Organizador do Setor',
  'Desvinculo de Usuário da organização':
    'Desvinculo de Usuário da organização',
  'Desvinculo de usuário do setor': 'Desvinculo de usuário do setor',
  'Detalhes da auditoria': 'Detalhes da auditoria',
  'Detalhes da conferência': 'Detalhes da conferência',
  'Detalhes da operação': 'Detalhes da operação',
  'Detalhes de organização': 'Detalhes de organização',
  'Detalhes do atendimento': 'Detalhes do atendimento',
  'Detalhes do setor': 'Detalhes do setor',
  'Detalhes do usuário': 'Detalhes do usuário',
  Detalhes: 'Detalhes',
  Dia: 'Dia',
  'Digite a confirmação da nova senha': 'Digite a confirmação da nova senha',
  'Digite a senha atual': 'Digite a senha atual',
  'Digite a senha da receita': 'Digite a senha da receita',
  'Digite apenas letras maiusculas e minúsculas e espaço.':
    'Digite apenas letras maiusculas e minúsculas e espaço.',
  'Digite nova senha': 'Digite nova senha',
  'Digite novamente a nova senha': 'Digite novamente a nova senha',
  'Digite o CPF do administrador': 'Digite o CPF do administrador',
  'Digite o CPF do organizador': 'Digite o CPF do organizador',
  'Digite o CPF do paciente': 'Digite o CPF do paciente',
  'Digite o código da receita': 'Digite o código da receita',
  'Digite o código do atendimento': 'Digite o código do atendimento',
  'Digite o código do paciente': 'Digite o código do paciente',
  'Digite o e-mail do profissional': 'Digite o e-mail do profissional',
  'Digite o nome de um médico': 'Digite o nome de um médico',
  'Digite o nome de um organizador': 'Digite o nome de um organizador',
  'Digite o nome do administrador': 'Digite o nome do administrador',
  'Digite o nome do organizador': 'Digite o nome do organizador',
  'Digite o nome do paciente': 'Digite o nome do paciente',
  'Digite o nome do participante': 'Digite o nome do participante',
  'Digite o nome do profissinal': 'Digite o nome do profissinal',
  'Digite o nome do profissional': 'Digite o nome do profissional',
  'Digite o nome ou e-mail de um participante...':
    'Digite o nome ou e-mail de um participante...',
  'Digite o número do seu celular': 'Digite o número do seu celular',
  'Digite o seu email': 'Digite o seu email',
  'Digite o(s) e-mail(s) para convidar': 'Digite o(s) e-mail(s) para convidar',
  'Digite o(s) email(s) para convidar': 'Digite o(s) email(s) para convidar',
  'Digite seu CEP': 'Digite seu CEP',
  'Digite seu bairro': 'Digite seu bairro',
  'Digite seu e-mail': 'Digite seu e-mail',
  'Digite seu estado': 'Digite seu estado',
  'Digite seu nome': 'Digite seu nome',
  'Digite seu país': 'Digite seu país',
  'Digite seu sobrenome': 'Digite seu sobrenome',
  'Digite sua Senha': 'Digite sua Senha',
  'Digite sua cidade': 'Digite sua cidade',
  'Digite um complemento': 'Digite um complemento',
  'Digite uma senha pessoal': 'Digite uma senha pessoal',
  Disponíveis: 'Disponíveis',
  Disponível: 'Disponível',
  'Documento clínico': 'Documento clínico',
  'Documento não enviado': 'Documento não enviado',
  'Documentos Clínicos': 'Documentos Clínicos',
  'Documentos clínicos': 'Documentos clínicos',
  'Documentos de apoio': 'Documentos de apoio',
  Domingo: 'Domingo',
  Dosagem: 'Dosagem',
  Droga: 'Droga',
  'Duração média': 'Duração média',
  'Duração total': 'Duração total',
  Duração: 'Duração',
  'E-mail confirmado em': 'E-mail confirmado em',
  'E-mail do profissional': 'E-mail do profissional',
  'E-mail enviado com sucesso!': 'E-mail enviado com sucesso!',
  'E-mail já cadastrado': 'E-mail já cadastrado',
  'E-mail reenviado com sucesso!': 'E-mail reenviado com sucesso!',
  'E-mail': 'E-mail',
  'Editar especialidade': 'Editar especialidade',
  'Editar organização': 'Editar organização',
  'Editar reunião recorrente': 'Editar atendimento recorrente',
  'Editar reunião': 'Editar atendimento',
  'Editar setor': 'Editar setor',
  'Editar usuário': 'Editar usuário',
  'Edição de conferência': 'Edição de conferência',
  'Em andamento': 'Em andamento',
  'Em progresso': 'Em progresso',
  'Email inválido.': 'Email inválido.',
  Email: 'Email',
  Emergency: 'Emergency',
  Endereço: 'Endereço',
  'Entrar com:': 'Entrar com:',
  'Entrar na consulta': 'Entrar na consulta',
  'Entrar na reunião': 'Entrar no atendimento',
  Entrar: 'Entrar',
  'Enviar ao Paciente': 'Enviar ao Paciente',
  'Enviar convite por Whatsapp': 'Enviar convite por Whatsapp',
  'Enviar documento por e-mail': 'Enviar documento por e-mail',
  'Enviar e concluir': 'Enviar e concluir',
  Enviar: 'Enviar',
  'Erro ao buscar dados da organização': 'Erro ao buscar dados da organização',
  'Erro ao buscar reunião': 'Erro ao buscar atendimento',
  'Especialidade inválida ou não encontrada':
    'Especialidade inválida ou não encontrada',
  Especialidade: 'Especialidade',
  'Esqueceu sua senha?': 'Esqueceu sua senha?',
  'Esta e todas as seguintes': 'Esta e todas as seguintes',
  Estado: 'Estado',
  Estatísticas: 'Estatísticas',
  'Este documento clinico será listado como Documento pendente e não será enviado ao paciente até que a assinatura seja finalizada.':
    'Este documento clinico será listado como Documento pendente e não será enviado ao paciente até que a assinatura seja finalizada.',
  'Este número é whatsapp': 'Este número é whatsapp?',
  Evento: 'Evento',
  'Eventos do atendimento': 'Eventos do atendimento',
  'Excluir Receita': 'Excluir Receita',
  'Excluir conta': 'Excluir conta',
  'Excluir documento': 'Excluir documento',
  'Excluir especialidade': 'Excluir especialidade',
  'Excluir reunião recorrente': 'Excluir atendimento recorrente',
  'Excluir usuario': 'Excluir usuario',
  'Excluir usuário': 'Excluir usuário',
  'Extrato de consumo detalhado': 'Extrato de consumo detalhado',
  FACE_RECOGNITION_API_COULD_NOT_ADD_FILE_TO_FORM: 'Erro ao ler o arquivo',
  FACE_RECOGNITION_API_COULD_NOT_CREATE_SUBJECT:
    'Não foi possível criar assunto',
  FACE_RECOGNITION_API_COULD_NOT_GET_SUBJECT:
    'Não foi possível obter o assunto',
  FACE_RECOGNITION_API_COULD_NOT_SEND_PICTURE: 'Não foi possível enviar a foto',
  FACE_RECOGNITION_API_COULD_NOT_UPDT_PICTURE:
    'Não foi possível atualizar a imagem do usuário',
  FACE_RECOGNITION_API_COULD_NOT_VERIFY_FACE:
    'Não foi possível verificar o rosto do usuário',
  FACE_RECOGNITION_API_COULD_NOT_VERIFY_SUBJECT:
    'Não foi possível verificar o assunto',
  FACE_RECOGNITION_API_NO_FACE_RECORD:
    'Usuário não possui registro facial anexado ao perfil',
  FILE_REQUIRED: 'Arquivo é necessário para esta ação',
  'Falha no servidor, tente novamente mais tarde.':
    'Falha no servidor, tente novamente mais tarde.',
  Faturamento: 'Faturamento',
  Fechar: 'Fechar',
  Feminino: 'Feminino',
  Fim: 'Fim',
  Finalizado: 'Finalizado',
  'Finalizar atendimento': 'Finalizar atendimento',
  'Formas de convite': 'Formas de convite',
  Forte: 'Forte',
  Fraca: 'Fraca',
  Geral: 'Geral',
  'Gerar documento com a transcrição da reunião':
    'Gerar documento com a transcrição do atendimento',
  'Se aplicam a todas as reuniões, mesmo nas recorrências.':
    'Se aplicam a todos os atendimentos, mesmo nas recorrências.',
  Gravadas: 'Gravadas',
  Gravado: 'Gravado',
  Gravados: 'Gravados',
  Gravação: 'Gravação',
  'Gravações do atendimento': 'Gravações do atendimento',
  Gravações: 'Gravações',
  Grupo: 'Grupo',
  Gênero: 'Gênero',
  HEALTHCHECK_FAILED: 'Verificação de integridade falhou',
  Hoje: 'Hoje',
  'Hora de início': 'Hora de início',
  'Hora de ínicio incorreta': 'Hora de ínicio incorreta',
  'Hora do fim': 'Hora do fim',
  'Hora fim': 'Hora fim',
  'Hora final incorreta': 'Hora final incorreta',
  'Hora início': 'Hora início',
  Hora: 'Hora',
  'Horas de reuniões': 'Horas de atendimentos',
  'Horas gravadas': 'Horas gravadas',
  Horas: 'Horas',
  ID: 'ID',
  Idade: 'Idade',
  'Imagem do usuário alterada com sucesso!':
    'Imagem do usuário alterada com sucesso!',
  'Informações da reunião': 'Informações do atendimento',
  'Informações do usuário atualizadas com sucesso!':
    'Informações do usuário atualizadas com sucesso!',
  'Informações do usuário atualizadas com sucesso':
    'Informações do usuário atualizadas com sucesso!',
  'Informações gerais': 'Informações gerais',
  'Informações históricas': 'Informações históricas',
  'Iniciar atendimento': 'Iniciar atendimento',
  'Insira a UF do seu documento profissional':
    'Insira a UF do seu documento profissional',
  'Insira a data de emissão do seu documento profissional':
    'Insira a data de emissão do seu documento profissional',
  'Insira a dosagem': 'Insira a dosagem',
  'Insira a posologia da medicação': 'Insira a posologia da medicação',
  'Insira o CÓDIGO e SENHA disponíveis na receita do paciente':
    'Insira o CÓDIGO e SENHA disponíveis na receita do paciente',
  'Insira o nome da droga': 'Insira o nome da droga',
  'Insira o nome da sua cidade.': 'Insira o nome da sua cidade.',
  'Insira o nome do seu bairro.': 'Insira o nome do seu bairro.',
  'Insira o número de sua residência': 'Insira o número de sua residência',
  'Insira o número do seu documento profissional':
    'Insira o número do seu documento profissional',
  'Insira o seu endereço.': 'Insira o seu endereço.',
  'Insira o tempo de afastamento': 'Insira o tempo de afastamento',
  'Insira seu nome completo.': 'Insira seu nome completo.',
  'Insira uma indicação clínica.': 'Insira uma indicação clínica.',
  Instituição: 'Instituição',
  Início: 'Início',
  'Ir para sala de espera': 'Ir para sala de espera',
  'Já existe um setor com este nome.': 'Já existe um setor com este nome.',
  'Já existe uma organização com este nome':
    'Já existe uma organização com este nome',
  LINK_GEN_API_COULD_NOT_CREATE_LINK: 'Não foi possível criar o link',
  LINK_GEN_API_LOGIN_ERROR:
    'Não foi possível fazer login no sistema LinkGenerator',
  Ligada: 'Ligada',
  Ligado: 'Ligado',
  'Limite de gravações mensais (horas)': 'Limite de gravações mensais (horas)',
  'Limite de reuniões mensais (horas)':
    'Limite de atendimentos mensais (horas)',
  'Limpar todas': 'Limpar todas',
  'Lista de Documentos clínicos': 'Lista de Documentos clínicos',
  'Lista de Documentos de apoio': 'Lista de Documentos de apoio',
  'Lista de organizações': 'Lista de organizações',
  'Lista de profissionais participantes':
    'Lista de profissionais participantes',
  'Lista de usuários': 'Lista de usuários',
  'Log de atividade': 'Log de atividade',
  Logados: 'Logados',
  'Login desabilitado com sucesso!': 'Login desabilitado com sucesso!',
  'Login habilitado com sucesso!': 'Login habilitado com sucesso!',
  'Login habilitado': 'Login habilitado',
  Login: 'Login',
  'Logo da organização alterado com sucesso!':
    'Logo da organização alterado com sucesso!',
  Logradouro: 'Logradouro',
  Manutenção: 'Manutenção',
  Masculino: 'Masculino',
  'Minha conta': 'Minha conta',
  'Minhas reuniões': 'Meus atendimentos',
  'Mudança de senha': 'Mudança de senha',
  'Mudar senha': 'Mudar senha',
  'Média de consumo diário': 'Média de consumo diário',
  'Média de participantes': 'Média de participantes',
  Médico: 'Médico',
  Médio: 'Médio',
  Mês: 'Mês',
  NOTIFICATION_API_CHECK_MESSAGE_EXIST:
    'Não foi possível verificar se a mensagem existe no serviço de centro de notificação',
  NOTIFICATION_API_COULD_NOT_SEND_MESSAGE:
    'Não foi possível enviar mensagem no serviço de centro de notificação',
  NOTIFICATION_API_COULD_NOT_SEND_MESSAGE_WITH_ATTACHEMENTS:
    'Não foi possível enviar mensagem com anexos no serviço de centro de notificação',
  NOTIFICATION_API_COULD_NOT_VERIFY_MESSAGE:
    'Não foi possível verificar a mensagem no serviço de notificações',
  NOTIFICATION_API_LOGIN_ERROR:
    'Não foi possível fazer login no serviço de centro de notificação',
  'Nome Completo': 'Nome Completo',
  'Nome completo': 'Nome completo',
  'Nome da Organização': 'Nome da Organização',
  'Nome da mãe é obrigatório.': 'Nome da mãe é obrigatório.',
  'Nome da mãe': 'Nome da mãe',
  'Nome da organização': 'Nome da organização',
  'Nome da pessoa de contato': 'Nome da pessoa de contato',
  'Nome da sua mãe': 'Nome da sua mãe',
  'Nome do Profissional': 'Nome do Profissional',
  'Nome do setor': 'Nome do setor',
  'Nome do usuário': 'Nome do usuário',
  Nome: 'Nome',
  Notificações: 'Notificações',
  'Nova Organização': 'Nova Organização',
  'Nova mensagem': 'Nova mensagem',
  'Nova reunião': 'Novo atendimento',
  'Nova senha': 'Nova senha',
  'Novo Administrador': 'Novo Administrador',
  'Novo Usuário': 'Novo Usuário',
  'Novo agendamento': 'Novo agendamento',
  'Novo documento clínico': 'Novo documento clínico',
  'Novo documento de apoio': 'Novo documento de apoio',
  'Novo documento': 'Novo documento',
  'Novo organizador': 'Novo organizador',
  'Novo paciente': 'Novo paciente',
  'Novo profissional': 'Novo profissional',
  'Novo setor': 'Novo setor',
  'Novos usuários': 'Novos usuários',
  'Não cancelar': 'Não cancelar',
  'Não foi possível alterar a senha': 'Não foi possível alterar a senha',
  'Não foi possível alterar senha': 'Não foi possível alterar senha',
  'Não foi possível atualizar a reunião':
    'Não foi possível atualizar o atendimento',
  'Não foi possível atualizar as informações do usuário':
    'Não foi possível atualizar as informações do usuário',
  'Não foi possível atualizar configurações da organização':
    'Não foi possível atualizar configurações da organização',
  'Não foi possível atualizar imagem do usuário':
    'Não foi possível atualizar imagem do usuário',
  'Não foi possível atualizar logo da organização':
    'Não foi possível atualizar logo da organização',
  'Não foi possível atualizar o setor.': 'Não foi possível atualizar o setor.',
  'Não foi possível atualizar organização':
    'Não foi possível atualizar organização',
  'Não foi possível buscar dados da organização do setor':
    'Não foi possível buscar dados da organização do setor',
  'Não foi possível buscar detalhes de administração do usuário':
    'Não foi possível buscar detalhes de administração do usuário',
  'Não foi possível buscar usuário.': 'Não foi possível buscar usuário.',
  'Não foi possível cadastrar a organização':
    'Não foi possível cadastrar a organização.',
  'Não foi possível carregar dados do usuário':
    'Não foi possível carregar dados do usuário',
  'Não foi possível carregar o arquivo': 'Não foi possível carregar o arquivo',
  'Não foi possível confirmar conta': 'Não foi possível confirmar conta',
  'Não foi possível criar a reunião': 'Não foi possível criar o atendimento',
  'Não foi possível criar o setor.': 'Não foi possível criar o setor.',
  'Não foi possível criar usuário': 'Não foi possível criar usuário',
  'Não foi possível desassociar o usuário do setor.':
    'Não foi possível desassociar o usuário do setor.',
  'Não foi possível desativar a câmera.':
    'Não foi possível desativar a câmera.',
  'Não foi possível desvincular o usuário da organização':
    'Não foi possível desvincular o usuário da organização',
  'Não foi possível enviar e-mail de recuperação':
    'Não foi possível enviar e-mail de recuperação',
  'Não foi possível enviar e-mail': 'Não foi possível enviar e-mail',
  'Não foi possível reenviar e-mail de confirmação':
    'Não foi possível reenviar e-mail de confirmação',
  'Não foi possível remover a reunião':
    'Não foi possível remover o atendimento',
  'Não foi possível remover a reunião.':
    'Não foi possível remover o atendimento.',
  'Não foi possível remover setor.': 'Não foi possível remover setor.',
  'Não foi possível remover usuário': 'Não foi possível remover usuário',
  'Não gravadas': 'Não gravadas',
  'Não gravado': 'Não gravado',
  'Não possui reuniões': 'Não possui atendimentos',
  'Não é possível deletar organização com usuários ativos':
    'Não é possível deletar organização com usuários ativos.',
  Não: 'Não',
  Nível: 'Nível',
  'Número da identidade': 'Número da identidade',
  'Número da residência': 'Número da residência',
  'Número de reuniões': 'Número de atendimentos',
  'Número inválido, ultrapassou o limite':
    'Número inválido, ultrapassou o limite',
  Número: 'Número',
  'O administrador geral tem permissões irrestritas no sistema. Esta alteração tem implicações no gerenciamento do sistema pois remove permissões de administração deste usuário.':
    'O administrador geral tem permissões irrestritas no sistema. Esta alteração tem implicações no gerenciamento do sistema pois remove permissões de administração deste usuário.',
  'O campo "Título de reunião" é obrigatório.':
    'O campo "Título de atendimento" é obrigatório.',
  'O e-mail não está em formato válido': 'O e-mail não está em formato válido',
  'O e-mail é obrigatório': 'O e-mail é obrigatório',
  'O moderador precisa entrar na reunião antes de qualquer participante?':
    'O moderador precisa entrar no atendimento antes de qualquer participante?',
  'O médico está pronto': 'O médico está pronto',
  'O médico foi informado que': 'O médico foi informado que',
  'O médico já está na sala de atendimento':
    'O médico já está na sala de atendimento',
  'O nome do setor deve conter no máximo 64 caracteres.':
    'O nome do setor deve conter no máximo 64 caracteres.',
  'O nome é obrigatório': 'O nome é obrigatório',
  'O paciente está pronto': 'O paciente está pronto',
  'O paciente foi informado que': 'O paciente foi informado que',
  'O telefone é obrigatório': 'O telefone é obrigatório',
  OK: 'OK',
  ORGUNIT_CANNOT_DELETE_ACTIVE_USERS:
    'Não é possível excluir setor com usuários ativos',
  ORGUNIT_COULD_NOT_LIST: 'Não foi possível listar o setor',
  ORGUNIT_EXPIRED: 'Setor expirado',
  ORGUNIT_LIMIT_REACHED:
    'Este setor já atingiu o limite de quantidade de unidades',
  ORGUNIT_NAME_ALREADY_IN_USE: 'Já existe um setor com este nome',
  ORGUNIT_NOT_CREATED: 'Não foi possível criar o setor',
  ORGUNIT_NOT_DELETED: 'Não foi possível deletar o setor',
  ORGUNIT_NOT_FOUND: 'Não foi possível encontrar o setor',
  ORGUNIT_NOT_UPDATED: 'Não foi possível atualizar o setor',
  ORGUNIT_PARENT_NOT_FOUND: 'Não foi possível encontrar o parente deste setor',
  ORGUNIT_SHORT_ALREADY_IN_USE: 'Já existe um setor com esta sigla',
  ORGUNIT_USER_LIMIT_REACHED:
    'Este setor já atingiu o limite de quantidade de usuários',
  ORG_ADMIN_COULD_NOT_LIST: 'Não foi possível listar os administradores',
  ORG_ADMIN_NOT_CREATED:
    'Não foi possível criar o administrador da organização',
  ORG_ADMIN_NOT_DELETED:
    'Não foi possível deletar o administrador da organização',
  ORG_ADMIN_NOT_FOUND:
    'Não foi possível encontrar o administrador da organização',
  ORG_APIKEY_DECRYPT_ERROR:
    'Não foi possível descriptografar a chave da API: Chave da API ausente ou inválida',
  ORG_CANNOT_DELETE_ACTIVE_USERS:
    'Não é possível excluir org com usuários ativos',
  ORG_COULD_NOT_LINK_USER: 'Não foi possível vincular o usuário à organização',
  ORG_COULD_NOT_LIST: 'Não foi possível listar as organizações',
  ORG_EXPIRED: 'Organização expirada',
  ORG_LIMIT_REACHED: 'Limite da unidade organizacional atingido',
  ORG_NOT_CREATED: 'Não foi possível criar a organização',
  ORG_NOT_DELETED: 'Não foi possível atualizar a organização',
  ORG_NOT_FOUND: 'Não foi possível encontrar a organização',
  ORG_NOT_UPDATED: 'Não foi possível atualizar a organização',
  ORG_SHORT_ALREADY_IN_USE: 'O nome curto da organização já está em uso',
  ORG_USER_COULD_NOT_LIST: 'Não foi possível listar os membros da organização',
  ORG_USER_LIMIT_REACHED:
    'A organização já atingiu o limite máximo de usuários',
  ORG_USER_NOT_DELETED:
    'Não foi possível remover o administrador da organização',
  ORG_USER_NOT_FOUND: 'Não foi possível encontrar o membro da organização',
  'Objeto da ação': 'Objeto da ação',
  'Ocultar notificações': 'Ocultar notificações',
  Ontem: 'Ontem',
  'Opção inválida': 'Opção inválida',
  Organizador: 'Organizador',
  'Organizadores cadastrados': 'Organizadores cadastrados',
  'Organizadores do setor': 'Organizadores do setor',
  Organizadores: 'Organizadores',
  'Organização atualizada com sucesso': 'Organização atualizada com sucesso!',
  'Organização criada com sucesso': 'Organização criada com sucesso!',
  'Organização expira?': 'Organização expira?',
  'Organização habilitada até:': 'Organização habilitada até:',
  'Organização removida com sucesso': 'Organização removida com sucesso!',
  Organização: 'Organização',
  'Organizações cadastradas': 'Organizações cadastradas',
  Organizações: 'Organizações',
  Origem: 'Origem',
  Outros: 'Outros',
  PARAMETER_COULD_NOT_LIST: 'Não foi possível listar os parâmetros do sistema',
  PARAMETER_NOT_FOUND: 'Não foi possível encontrar o parâmetro',
  PARAMETER_VALUE_ALREADY_EXISTS: 'O valor do parâmetro já existe',
  PARAMETER_VALUE_COULD_NOT_LIST:
    'Não foi possível listar os valores do parâmetro',
  PARAMETER_VALUE_NOT_FOUND: 'Não foi possível encontrar o valor do parâmetro',
  'Paciente em questão': 'Paciente em questão',
  Paciente: 'Paciente',
  'Pacientes cadastrados': 'Pacientes cadastrados',
  Pacientes: 'Pacientes',
  'Painel de monitoramento': 'Painel de monitoramento',
  'Painel de reuniões': 'Painel de atendimentos',
  Painel: 'Painel',
  Painéis: 'Painéis',
  Papel: 'Papel',
  'Para reagendar ou alterar dados do atendimento, você precisa editar o atendimento nos campos ao lado.':
    'Para reagendar ou alterar dados do atendimento, você precisa editar o atendimento nos campos ao lado.',
  Participante: 'Participante',
  'Participantes da Consulta': 'Participantes da Consulta',
  Participantes: 'Participantes',
  'Participar do atendimento': 'Participar do atendimento',
  País: 'País',
  Pendente: 'Pendente',
  'Perfil do usuário': 'Perfil do usuário',
  Perfil: 'Perfil',
  Permissão: 'Permissão',
  'Permissões concedidas': 'Permissões concedidas',
  'Permite gravação de reuniões?': 'Permite gravação de atendimentos?',
  Período: 'Período',
  'Pesquisar usuário': 'Pesquisar usuário',
  Pesquisar: 'Pesquisar',
  'Política de privacidade': 'Política de privacidade',
  Posologia: 'Posologia',
  'Prazo para confirmação': 'Prazo para confirmação',
  Prescrição: 'Prescrição',
  'Profissionais cadastrados': 'Profissionais cadastrados',
  'Profissionais de saúde': 'Profissionais de saúde',
  'Profissionais participantes': 'Profissionais participantes',
  Profissionais: 'Profissionais',
  'Profissional da saúde': 'Profissional da saúde',
  'Profissional de saúde': 'Profissional de saúde',
  'Profissional inválido ou não encontrado.':
    'Profissional inválido ou não encontrado.',
  Profissional: 'Profissional',
  Profissão: 'Profissão',
  'Pronto para participar?': 'Pronto para participar?',
  Próximo: 'Próximo',
  'Quais das reuniões associadas a este evento você deseja editar?':
    'Quais das reuniões associadas a este evento você deseja editar?',
  'Quais das reuniões associadas a este evento você deseja excluir?':
    'Quais das reuniões associadas a este evento você deseja excluir?',
  Qualquer: 'Qualquer',
  'Quantidade de reuniões': 'Quantidade de atendimentos',
  'Quarta-Feira': 'Quarta-Feira',
  'Quinta-Feira': 'Quinta-Feira',
  'RG inválido, existe(m) digitos faltando':
    'RG inválido, existe(m) digitos faltando',
  'RG inválido, número de digitos ultrapassou o limite':
    'RG inválido, número de digitos ultrapassou o limite',
  'RG inválido.': 'RG inválido.',
  'Ranking de organizações': 'Ranking de organizações',
  'Ranking de usuários': 'Ranking de usuários',
  Realizadas: 'Realizadas',
  'Receita Antimicrobiano': 'Receita Antimicrobiano',
  'Receita Especial': 'Receita Especial',
  'Receita Simples': 'Receita Simples',
  'Receita simples': 'Receita simples',
  'Recomendamos que entre com o microfone e câmera ligados.':
    'Recomendamos que entre com o microfone e câmera ligados.',
  'Recursos Humanos': 'Recursos Humanos',
  'Redefinir senha': 'Redefinir senha',
  Redefinir: 'Redefinir',
  'Redefinição de senha': 'Redefinição de senha',
  'Reenviar confirmação': 'Reenviar confirmação',
  'Reenviar email': 'Reenviar email',
  'Registrar reunião na blockchain': 'Registrar atendimento na blockchain',
  'Registrar reunião na blockchain:': 'Registrar atendimento na blockchain:',
  'Registro de conselho': 'Registro de conselho',
  'Registro no conselho profissional': 'Registro no conselho profissional',
  'Remover organização': 'Remover organização',
  'Remover setor': 'Remover setor',
  'Remover usuário': 'Remover usuário',
  'Remoção de Organização': 'Remoção de Organização',
  'Remoção de Reunião': 'Remoção de Atendimento',
  'Remoção de Usuário': 'Remoção de Usuário',
  'Remoção de setor': 'Remoção de setor',
  'Repita a senha de acesso': 'Repita a senha de acesso',
  'Repita nova senha': 'Repita nova senha',
  'Requisição de Exames': 'Requisição de Exames',
  'Requisição de exame': 'Requisição de exame',
  Retorno: 'Retorno',
  'Reunião Agendada com sucesso!': 'Atendimento Agendada com sucesso!',
  'Reunião excluida com sucesso': 'Atendimento excluida com sucesso',
  'Reunião instantânea': 'Atendimento instantânea',
  Reunião: 'Atendimento',
  'Reuniões gravadas': 'Atendimentos gravados',
  'Reuniões não gravadas': 'Atendimentos não gravados',
  'Reuniões transcritas': 'Atendimentos transcritos',
  Reuniões: 'Atendimentos',
  Rg: 'Rg',
  'Rua Av. Ladeira...': 'Rua Av. Ladeira...',
  SAC_REQUEST_ALREADY_ATTENDED: 'A solicitação SAC já está sendo atendida',
  SAC_REQUEST_ALREADY_BELONGS_TO_TOPIC:
    'A solicitação SAC já pertence a este tópico',
  SAC_REQUEST_ALREADY_FINISHED: 'A solicitação SAC já foi finalizada',
  SAC_REQUEST_COULD_NOT_LIST: 'Não foi possível listar as solicitações SAC',
  SAC_REQUEST_NAME_ALREADY_IN_USE: 'O nome da solicitação SAC já está em uso',
  SAC_REQUEST_NOT_ATTENDING: 'A solicitação SAC ainda não está sendo atendida',
  SAC_REQUEST_NOT_CREATED: 'Não foi possível criar a solicitação SAC',
  SAC_REQUEST_NOT_DELETED: 'Não foi possível excluir a solicitação SAC',
  SAC_REQUEST_NOT_FOUND: 'Solicitação SAC não encontrada',
  SAC_REQUEST_NOT_IN_SCHEDULE: 'A solicitação SAC não está na agenda',
  SAC_REQUEST_NOT_SPECIALIST: 'O usuário não é especialista para este tópico',
  SAC_REQUEST_NOT_THE_SPECIALIST:
    'O usuário não é o especialista para esta solicitação',
  SAC_REQUEST_NOT_UPDATED: 'Não foi possível atualizar a solicitação SAC',
  SAC_REQUEST_NO_SCHEDULE: 'SAC não tem horário definido',
  SAC_REQUEST_NO_SPECIALIST: 'A solicitação SAC não tem especialista',
  SAC_SPECIALIST_NOT_FOUND: 'Especialista SAC não encontrado',
  SAC_TOPIC_COULD_NOT_LIST: 'Não foi possível listar os tópicos SAC',
  SAC_TOPIC_NAME_ALREADY_IN_USE: 'O nome do tópico SAC já está em uso',
  SAC_TOPIC_NOT_ACTIVE: 'O tópico SAC não está ativo',
  SAC_TOPIC_NOT_CREATED: 'Não foi possível criar o tópico SAC',
  SAC_TOPIC_NOT_DELETED: 'Não foi possível excluir o tópico SAC',
  SAC_TOPIC_NOT_FOUND: 'Tópico SAC não encontrado',
  SAC_TOPIC_NOT_UPDATED: 'Não foi possível atualizar o tópico SAC',
  SESSION_MANAGER_BILLING_NOT_FOUND: 'Não foi possível encontrar o faturamento',
  SESSION_MANAGER_COULD_NOT_CREATE_ORG: 'Não foi possível criar a organização',
  SESSION_MANAGER_COULD_NOT_CREATE_ORGUNIT:
    'Não foi possível criar orgUnit no Session Manager',
  SESSION_MANAGER_COULD_NOT_CREATE_ROOM:
    'Não foi possível criar espaço no Session Manager',
  SESSION_MANAGER_COULD_NOT_CREATE_USER:
    'Não foi possível criar usuário no Session Manager',
  SESSION_MANAGER_COULD_NOT_DELETE_ORG: 'Não foi possível deletar org',
  SESSION_MANAGER_COULD_NOT_DELETE_ORGUNIT: 'Não foi possível excluir orgUnit',
  SESSION_MANAGER_COULD_NOT_DELETE_USER: 'Não foi possível excluir o usuário',
  SESSION_MANAGER_COULD_NOT_DOWNLOAD_REGISTRY:
    'Não foi possível encontrar o download no Gerenciador de Sessões',
  SESSION_MANAGER_COULD_NOT_GET_DASHBOARD:
    'Não foi possível obter informações do painel do SessionManager',
  SESSION_MANAGER_COULD_NOT_GET_INFO: 'Não foi possível obter informações',
  SESSION_MANAGER_COULD_NOT_GET_RECORDING:
    'Não foi possível encontrar a gravação no Session Manager',
  SESSION_MANAGER_COULD_NOT_GET_REGISTRY:
    'Não foi possível encontrar o registro no Gerenciador de Sessões',
  SESSION_MANAGER_COULD_NOT_GET_USER:
    'Não foi possível obter informações do usuário do SessionManager',
  SESSION_MANAGER_COULD_NOT_JOIN_ROOM:
    'Não foi possível entrar na sala no Session Manager',
  SESSION_MANAGER_COULD_NOT_LIST_RECORDING:
    'Não foi possível recuperar as gravações do Session Manager',
  SESSION_MANAGER_COULD_NOT_OPEN_ROOM:
    'Não foi possível abrir a sala no Session Manager',
  SESSION_MANAGER_COULD_NOT_UPDATE_ORG:
    'Não foi possível atualizar a organização',
  SESSION_MANAGER_COULD_NOT_UPDATE_ORGUNIT:
    'Não foi possível atualizar orgUnit',
  SESSION_MANAGER_COULD_NOT_UPDATE_USER: 'Não foi possível atualizar orgUnit',
  SESSION_MANAGER_COULD_NOT_VERIFY_REGISTRY:
    'Não foi possível verificar o registro no Gerenciador de Sessões',
  SESSION_MANAGER_ORGUNIT_ALREADY_EXISTS:
    'OrgUnit com este nome abreviado já existe',
  SESSION_MANAGER_ORG_ALREADY_EXISTS: 'Org com este nome abreviado já existe',
  SESSION_MANAGER_REGISTRY_NOT_FOUND: 'Registro não encontrado',
  SESSION_MANAGER_USER_ALREADY_EXISTS: 'Usuário com este login já existe',
  SETTING_DYNAMIC_GET:
    'O sistema parece estar faltando configurações obrigatórias.',
  SKIN_NAME_ALREADY_IN_USE: 'Nome da skin já em uso',
  SKIN_NOT_CREATED: 'Não foi possível criar skin',
  SKIN_NOT_DELETED: 'Não foi possível atualizar a skin',
  SKIN_NOT_FOUND: 'Não foi possível encontrar a skin',
  SKIN_NOT_UPDATED: 'Não foi possível atualizar a skin',
  STORAGE_COULD_NOT_DELETE_FILE:
    'Não foi possível excluir o arquivo do serviço de armazenamento',
  STORAGE_COULD_NOT_GET_URL:
    'Não foi possível obter o URL do arquivo do serviço de armazenamento',
  STORAGE_COULD_NOT_SEND_FILE:
    'Não foi possível enviar o arquivo do serviço de armazenamento',
  SYSTEM_SETTING_NAME_ALREADY_IN_USE: 'Nome SystemSetting já em uso',
  SYSTEM_SETTING_NOT_CREATED: 'Não foi possível criar systemSetting',
  SYSTEM_SETTING_NOT_DELETED: 'Não foi possível atualizar systemSetting',
  SYSTEM_SETTING_NOT_FOUND: 'Não foi possível encontrar systemSetting',
  SYSTEM_SETTING_NOT_RESETED:
    'Não foi possível redefinir as configurações do sistema',
  SYSTEM_SETTING_NOT_UPDATED: 'Não foi possível atualizar systemSetting',
  'Sair do atendimento': 'Sair do atendimento',
  Sair: 'Sair',
  'Salvar alterações': 'Salvar alterações',
  Salvar: 'Salvar',
  'Segunda-Feira': 'Segunda-Feira',
  Segurança: 'Segurança',
  'Selecione a área de atendimento': 'Selecione a área de atendimento',
  'Selecione seu Gênero': 'Selecione seu Gênero',
  'Selecione seu certificado digital e finalize a criação do documento agora.':
    'Selecione seu certificado digital e finalize a criação do documento agora.',
  'Selecione sua profissão': 'Selecione sua profissão',
  'Selecione um Setor': 'Selecione um Setor',
  'Selecione um certificado': 'Selecione um certificado',
  'Selecione um paciente': 'Selecione um paciente',
  'Selecione um papel': 'Selecione um papel',
  'Selecione um profissional': 'Selecione um profissional',
  'Selecione um tipo de documento clínico':
    'Selecione um tipo de documento clínico',
  'Selecione um tipo': 'Selecione um tipo',
  'Selecione uma Organização': 'Selecione uma Organização',
  'Selecione uma data disponível': 'Selecione uma data disponível',
  'Selecione uma data': 'Selecione uma data',
  'Selecione uma especialidade': 'Selecione uma especialidade',
  'Selecione uma opção': 'Selecione uma opção',
  Selecione: 'Selecione',
  'Seleção de papeis': 'Seleção de papeis',
  'Sem atividade': 'Sem atividade',
  'Senha alterada com sucesso!': 'Senha alterada com sucesso!',
  'Senha atual': 'Senha atual',
  'Senha de Acesso': 'Senha de Acesso',
  'Senha de': 'Senha de',
  'Senha inválida': 'Senha inválida',
  Senha: 'Senha',
  'Senha:': 'Senha:',
  'Serviços Gerais': 'Serviços Gerais',
  'Serviços e faturamentos': 'Serviços e faturamentos',
  Serviços: 'Serviços',
  'Setor atualizado com sucesso!': 'Setor atualizado com sucesso!',
  'Setor criado com sucesso!': 'Setor criado com sucesso!',
  'Setor excluído com sucesso!': 'Setor excluído com sucesso!',
  Setor: 'Setor',
  Setores: 'Setores',
  'Seu nome completo': 'Seu nome completo',
  'Seu primeiro nome': 'Seu primeiro nome',
  'Seu segundo nome': 'Seu segundo nome',
  'Seus agendamentos aparecerão aqui. Não há itens a serem exibidos no momento.':
    'Seus agendamentos aparecerão aqui. Não há itens a serem exibidos no momento.',
  'Sexta-Feira': 'Sexta-Feira',
  Sigla: 'Sigla',
  'Sim, cancelar': 'Sim, cancelar',
  Sim: 'Sim',
  Simples: 'Simples',
  'Solicite a farmácia que acesse o endereço':
    'Solicite a farmácia que acesse o endereço',
  State: 'State',
  'Status do atendimento': 'Status do atendimento',
  Status: 'Status',
  'Sua relação familiar com o paciente': 'Sua relação familiar com o paciente',
  Sábado: 'Sábado',
  TEMPLATE_NOT_FOUND: 'Não foi possível encontrar o modelo de mensagem',
  Tamanho: 'Tamanho',
  'Tecnologia da Informação': 'Tecnologia da Informação',
  'Telefone 1': 'Telefone 1',
  'Telefone 2': 'Telefone 2',
  'Telefone alternativo': 'Telefone alternativo',
  'Telefone celular 1': 'Telefone celular 1',
  'Telefone celular 2': 'Telefone celular 2',
  'Telefone celular': 'Telefone celular',
  'Telefone inválido.': 'Telefone inválido.',
  Telefone: 'Telefone',
  'Termos de uso': 'Termos de uso',
  'Terça-Feira': 'Terça-Feira',
  'Tipo de Atendimento': 'Tipo de Atendimento',
  'Tipo de documento': 'Tipo de documento',
  'Tipo de serviço': 'Tipo de serviço',
  Tipo: 'Tipo',
  'Todas as organizações': 'Todas as organizações',
  'Todas as reuniões': 'Todos os atendimentos',
  'Todos os setores': 'Todos os setores',
  Total: 'Total',
  'Transcrever reunião': 'Transcrever atendimento',
  'Título de reunião': 'Título de atendimento',
  Título: 'Título',
  'UF inválido, existe(m) caracteres faltando':
    'UF inválido, existe(m) caracteres faltando',
  'UF inválido, número de caracteres ultrapassados':
    'UF inválido, número de caracteres ultrapassados',
  'UF inválido.': 'UF inválido.',
  UF: 'UF',
  UNRECOGNIZED_ORDERBY: 'Coluna de pedido não reconhecida',
  'URL copiada para a área de transferência':
    'URL copiada para a área de transferência',
  USERACTION_ALREADY_EXISTS: 'UserAction com este nome já existe',
  USERACTION_COULD_NOT_LIST:
    'Não foi possível listar userActions no banco de dados',
  USERACTION_GROUP_ALREADY_EXISTS: 'UserActionGroup com este nome já existe',
  USERACTION_GROUP_COULD_NOT_LIST:
    'Não foi possível listar userActionGroup no banco de dados',
  USERACTION_GROUP_NOT_CREATED:
    'Não foi possível criar UserActionGroup no banco de dados',
  USERACTION_GROUP_NOT_FOUND: 'Não foi possível encontrar UserActionGroup',
  USERACTION_LOG_COULD_NOT_LIST:
    'Não foi possível listar os logs do usuário no banco de dados',
  USERACTION_NOT_CREATED: 'Não foi possível criar UserAction no banco de dados',
  USERACTION_NOT_FOUND: 'Não foi possível encontrar UserAction',
  USER_ALREADY_AGREED: 'O usuário já concordou com os Termos',
  USER_ALREADY_CONFIRMED:
    'Não foi possível listar conferências no banco de dados',
  USER_ALREADY_EXISTS: 'Login de usuário ou e-mail já em uso',
  USER_ALREADY_IN_ORG:
    'O usuário já está atribuído a esta organização e unidade',
  USER_COULD_NOT_FIND_ORG:
    'Não foi possível encontrar a organização do usuário',
  USER_COULD_NOT_LIST: 'Não foi possível listar conferências no banco de dados',
  USER_NOT_CREATED: 'Não foi possível criar o usuário',
  USER_NOT_DELETED: 'Não foi possível deletar o usuário',
  USER_NOT_FOUND: 'Não foi possível encontrar o usuário',
  USER_NOT_IN_ORG: 'O usuário não existe nesta organização',
  USER_NOT_UPDATED: 'Não foi possível atualizar o usuário',
  USER_SUSPENDED: 'Usuário suspenso',
  'Um Link estará disponível após a confirmação do agendamento.':
    'Um Link estará disponível após a confirmação do agendamento.',
  'Um e-mail será enviado para o usuário com instruções para alteração de senha. O usuário ainda poderá fazer login com a senha atual até a alteração.':
    'Um e-mail será enviado para o usuário com instruções para alteração de senha. O usuário ainda poderá fazer login com a senha atual até a alteração.',
  'Um link estará disponível após confirmação do agendamento':
    'Um link estará disponível após confirmação do agendamento',
  'Uma mensagem será enviada para o endereço de e-mail acima para verificação da autenticidade e associação do endereço de e-mail ao usuário.':
    'Uma mensagem será enviada para o endereço de e-mail acima para verificação da autenticidade e associação do endereço de e-mail ao usuário.',
  'Usuário criado com sucesso!': 'Usuário criado com sucesso!',
  'Usuário criado com sucesso': 'Usuário criado com sucesso!',
  'Usuário desassociado com sucesso': 'Usuário desassociado com sucesso',
  'Usuário desassociado do setor com sucesso!':
    'Usuário desassociado do setor com sucesso!',
  'Usuário não é mais administrador do sistema!':
    'Usuário não é mais administrador do sistema!',
  'Administrador do Sistema': 'Administrador do Sistema',
  'Usuário promovido com sucesso!': 'Usuário promovido com sucesso!',
  'Usuário removido com sucesso': 'Usuário removido com sucesso!',
  Usuário: 'Usuário',
  'Usuários Cadastrados': 'Usuários Cadastrados',
  'Usuários ativos': 'Usuários ativos',
  'Usuários lotados': 'Usuários lotados',
  'Usuários padrão': 'Usuários padrão',
  Usuários: 'Usuários',
  Utilizados: 'Utilizados',
  'Utilize o código e senha para acessar':
    'Utilize o código e senha para acessar',
  VALIDATOR_DEFAULT_ISSUE: 'Erro de validação desconhecido',
  VALIDATOR_REQUIRED_FIELD: 'Campo obrigatório faltando',
  VALIDATOR_UNRECOGNIZED_FIELD: 'Campo não reconhecido',
  'Validador ICP Brasil': 'Validador ICP Brasil',
  'Valor Total': 'Valor Total',
  Valor: 'Valor',
  Vencimento: 'Vencimento',
  'Ver QR Code': 'Ver QR Code',
  'Ver organização': 'Ver organização',
  'Ver perfil': 'Ver perfil',
  'Ver setor': 'Ver setor',
  Vigência: 'Vigência',
  'Vincular usuário existente': 'Vincular usuário existente',
  Visualização: 'Visualização',
  'Você já pode iniciar o atendimento': 'Você já pode iniciar o atendimento',
  'Você já pode iniciar seu atendimento':
    'Você já pode iniciar seu atendimento',
  'Você não pode editar o usuário sem uma organização':
    'Você não pode editar o usuário sem uma organização',
  'Você não tem nenhum documento associado ao atendimento.':
    'Você não tem nenhum documento associado ao atendimento.',
  'Você não tem nenhuma gravação.': 'Você não tem nenhuma gravação.',
  'Você poderá fazer o download da gravação assim que disponível.':
    'Você poderá fazer o download da gravação assim que disponível.',
  'Você poderá fazer o download do registro assim que estiver disponível.':
    'Você poderá fazer o download do registro assim que estiver disponível.',
  'Você precisa concordar com os termos de uso da':
    'Você precisa concordar com os termos de uso da',
  'Você saiu da reunião': 'Você saiu do atendimento',
  'Você será avisado quando o': 'Você será avisado quando o',
  Voltar: 'Voltar',
  Vínculo: 'Vínculo',
  WEBSOCKET_API_ERROR: 'Problema ao enviar solicitações para a API WebSocket',
  'agendou o atendimento': 'agendou o atendimento',
  anos: 'anos',
  'atendimentos neste dia': 'atendimentos neste dia',
  'atualizou um atendimento': 'atualizou um atendimento',
  'cancelou um atendimento': 'cancelou um atendimento',
  'clicando em avançar': 'clicando em avançar',
  'confirmou o atendimento': 'confirmou o atendimento',
  'criou um atendimento com profissional acompanhante':
    'criou um atendimento com profissional acompanhante',
  'criou um atendimento': 'criou um atendimento',
  'deletou um atendimento': 'deletou um atendimento',
  'entrou na sala de espera': 'entrou na sala de espera',
  'médico estiver pronto': 'médico estiver pronto',
  'nesta sala de espera': 'nesta sala de espera',
  'não confirmado': 'não confirmado',
  'não fez login': 'não fez login',
  'para baixar sua receita digital.': 'para baixar sua receita digital.',
  'para visualizar o arquivo assinado pelo médico':
    'para visualizar o arquivo assinado pelo médico',
  'plataforma e também concordar que o atendimento poderá':
    'plataforma e também concordar que o atendimento poderá',
  reunião: 'atendimento',
  'saiu da sala de espera': 'saiu da sala de espera',
  segurança: 'segurança',
  'sem prazo para confirmação': 'sem prazo para confirmação',
  'ser gravado mediante escolha do médico.':
    'ser gravado mediante escolha do médico.',
  'termos de uso': 'termos de uso',
  'termos de uso.': 'termos de uso.',
  usado: 'usado',
  usuários: 'usuários',
  'via o QR code do documento': 'via o QR code do documento',
  'você está na sala de espera': 'você está na sala de espera',
  Ínicio: 'Ínicio',
  Órgão: 'Órgão',
  'Última edição': 'Última edição',
  'Últimas conversas': 'Últimas conversas',
  'Último acesso': 'Último acesso',
  'Último login em': 'Último login em',
  'Últimos 12 meses': 'Últimos 12 meses',
  'Últimos 30 dias': 'Últimos 30 dias',
  'Últimos 7 dias': 'Últimos 7 dias',
  'Últimos 90 dias': 'Últimos 90 dias',
  'Seja bem vindo ao': 'Seja bem vindo ao',
  'Consulte também os': 'Consulte também os',
  'Termos de Serviço': 'Termos de Serviço',
  e: 'e',
  'Políticas de Privacidade': 'Políticas de Privacidade',
  'Fazer Login': 'Fazer Login',
  'Lembrar-me': 'Lembrar-me',
  Versão: 'Versão',
  Suporte: 'Suporte',
  'Administrador da Organização': 'Administrador da Organização',
  'Organizador do Setor': 'Organizador do Setor',
  'Usuário Padrão': 'Usuário Padrão',
  Moderador: 'Moderador',
  Auditoria: 'Auditoria',
  'Detalhes da organização': 'Detalhes da organização',
  'Informações de consumo e faturamento':
    'Informações de consumo e faturamento',
  'SAC - Atende Fácil': 'SAC - Atende Fácil',
  'Código Postal': 'Código Postal',
  'Auditoria de ações realizadas pelos usuários':
    'Auditoria de ações realizadas pelos usuários',
  'Digite o email cadastrado': 'Digite o email cadastrado',
  'Digite sua senha': 'Digite sua senha',
  ' Todos os direitos reservados.': ' Todos os direitos reservados.',
  'Selecione um atendimento ao lado': 'Selecione um reunião ao lado',
  'Selecione o Estado': 'Selecione o Estado',
  'Selecione a cidade': 'Selecione a cidade',
  Aguardando: 'Aguardando',
  Finalizados: 'Finalizados',
  'Solicitado em': 'Solicitado em',
  Solicitante: 'Solicitante',
  Assunto: 'Assunto',
  'Detalhes da solicitação': 'Detalhes da solicitação',
  'ID de atendimento': 'ID de reunião',
  Atendente: 'Atendente',
  'Aceitar Solicitação': 'Aceitar Solicitação',
  Resolvido: 'Resolvido',
  Transferido: 'Transferido',
  'Não resolvido': 'Não resolvido',
  Interrompido: 'Interrompido',
  Identificação: 'Identificação',
  'Data de cadastro': 'Data de cadastro',
  'A partir de': 'A partir de',
  'Papéis e permissões': 'Papéis e permissões',
  'Administradores do sistema': 'Administradores do sistema',
  'Responsáveis por uma organização': 'Responsáveis por uma organização',
  'Responsáveis por um setor': 'Responsáveis por um setor',
  'Restaurar padrões': 'Restaurar padrões',
  'Aplicar filtros': 'Aplicar filtros',
  Até: 'Até',
  Ação: 'Ação',
  'Seleção de usuários': 'Seleção de usuários',
  'Data e hora da ocorrência do evento': 'Data e hora da ocorrência do evento',
  'Seleção do tipo de evento': 'Seleção do tipo de evento',
  Todos: 'Todos',
  Todas: 'Todas',
  'Apenas eventos que modificaram dados':
    'Apenas eventos que modificaram dados',
};

export default pt;
